import { createReducer, on } from '@ngrx/store';
import {
  addDeviceExplorerDataAction,
  setDeviceExplorerAvailableDateRangeAction,
  setDeviceExplorerDataCurrentRangeAction,
} from './actions';
import { IDeviceExplorerDataModel } from '../productionexplorer/models';

const initial: IDeviceExplorerDataModel = {
  explorerData: [],
  range: {
    // 30 days ago. This ugliness per https://stackoverflow.com/a/31665235/947
    minDate: new Date(new Date().setDate(new Date().getDate() - 30)),
    maxDate: new Date(),
  },
};

export const deviceExplorerDataReducer = createReducer(
  initial,

  on(addDeviceExplorerDataAction, (state, { payload }) => {
    const byDesc = (selector) => (a, b) => selector(b) - selector(a);

    const merged = [...payload, ...state.explorerData];

    const uniqueById = Array.from(new Map(merged.map((item) => [item.id, item])).values());

    return {
      ...state,
      explorerData: uniqueById.sort(byDesc((item) => new Date(item.date).getTime())),
    };
  }),
  on(setDeviceExplorerDataCurrentRangeAction, (state) => ({ ...state, explorerData: [] })),

  on(setDeviceExplorerDataCurrentRangeAction, (state) => ({ ...state, explorerData: [] })),

  on(setDeviceExplorerAvailableDateRangeAction, (state, { payload }) => ({
    ...state,
    range: payload,
  }))
);
